export { allMatches } from './allMatches';
export { allTeams } from './allTeams';
export { lineup } from './lineup';
export { match } from './match';
export { matchStats } from './matchStats';
export { team } from './team';
export { isMockDataActive } from './isMockDataActive';
export { structure } from './structure';
export { actions } from './actions';
export { standings } from './standings'
export { roster } from './roster';


// WEBPACK FOOTER //
// ./src/mundial/requests/mockData/index.ts